import { render, staticRenderFns } from "./ActivityButton.vue?vue&type=template&id=54d75452&scoped=true&"
import script from "./ActivityButton.vue?vue&type=script&lang=js&"
export * from "./ActivityButton.vue?vue&type=script&lang=js&"
import style0 from "./ActivityButton.vue?vue&type=style&index=0&id=54d75452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d75452",
  null
  
)

export default component.exports